import type { AppRouteRecordRaw } from '@/router/types'

export const callCenterRoutes: AppRouteRecordRaw[] = [
  {
    path: 'callCenter',
    name: 'CallCenter',
    component: () => import('@/views/callCenter/index.vue'),
    meta: {
      title: '呼叫中心',
      icon: 'leixingbumenshanxuanactiveno'
    },
    children: [
      {
        path: 'turnCallManage',
        name: 'TurnCallManage',
        component: () => import('@/views/callCenter/turnCallManage/index.vue'),
        meta: {
          title: '智能轮呼'
        }
      },
      {
        path: 'turnCallDetail',
        name: 'TurnCallDetail',
        component: () => import('@/views/callCenter/turnCallManage/turnCallDetail/index.vue'),
        meta: { title: '轮呼详情' }
      },
      {
        path: 'cloudGroupCall',
        name: 'CloudGroupCall',
        component: () => import('@/views/callCenter/cloudGroupCall/index.vue'),
        meta: {
          title: '群呼任务'
        }
      },
      {
        path: 'callRecords',
        name: 'CallRecords',
        component: () => import('@/views/callCenter/callRecords/index.vue'),
        meta: {
          title: '通话记录'
        }
      },
      {
        path: 'groupCallAssistant',
        name: 'GroupCallAssistant',
        component: () => import('@/views/callCenter/groupCallAssistant/index.vue'),
        meta: {
          title: '群呼助手'
        }
      },
      {
        path: 'cloudGroupCallLossData',
        name: 'CloudGroupCallLossData',
        component: () => import('@/views/callCenter/cloudGroupCall/lossData/index.vue'),
        meta: { title: '云群呼话损数据' }
      },
      {
        path: 'cloudGroupCallDetail',
        name: 'CloudGroupCallDetail',
        component: () => import('@/views/callCenter/cloudGroupCall/cloudGroupCallDetail/index.vue'),
        meta: { title: '云群呼详情' }
      },
      {
        path: 'visitBackCallRecord',
        name: 'VisitBackCallRecord',
        component: () => import('@/views/cps/visitBackRecord/index.vue'),
        meta: { title: '回访通话记录' }
      }
    ]
  }
]
